import * as React from "react";
import { gql, useMutation, useApolloClient } from "@apollo/client";
import { 
  LoginMutationMutation, 
  LoginMutationMutationVariables
} from "../../../../schemaTypes";
import { normalizeErrors } from "../../../../utils/normalizeErrors";
import { NormalizedErrorMap } from "../../../../types/NormalizedErrorMap";

const loginMutation = gql`
  mutation LoginMutation(
    $email: String!
    $password: String!
  ) {
    login(
      email: $email
      password: $password
    ) {
      errors {
        path
        message
      }
      sessionId
      message
    }
  }
`;

interface Props {
  onSessionId?: (sessionId: string) => void;
  children: (
    data: {
      submit: (
        values: LoginMutationMutationVariables
      ) => Promise<{ errors?: NormalizedErrorMap; message?: string | null; sessionId?: string | null } | null>;
    }
  ) => React.ReactElement | null;
}

export const LoginController: React.FC<Props> = ({ children, onSessionId }) => {
  const [_loginMutation] = useMutation<LoginMutationMutation, LoginMutationMutationVariables>(loginMutation);
  const client = useApolloClient();

  const submit = async (values: LoginMutationMutationVariables) => {
    const { data } = await _loginMutation({ variables: values });
    const errors = data?.login?.errors;
    const sessionId = data?.login?.sessionId ?? null;
    const message = ("message" in (data?.login ?? {})) ? (data?.login as any).message : null;

    if (errors && errors.length > 0) {
      return { errors: normalizeErrors(errors), message, sessionId };
    }

    if (sessionId && onSessionId) {
      onSessionId(sessionId);
    }

    await client.resetStore();

    return { errors: undefined, message, sessionId };
  };

  return children({ submit });
};